import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const ToastCtx = createContext(null);

const COLORS = {
  success: 'from-emerald-500/90 to-emerald-600/90 border-emerald-400/30',
  error: 'from-red-500/90 to-red-600/90 border-red-400/30',
  info: 'from-blue-500/90 to-blue-600/90 border-blue-400/30',
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const show = useCallback((message, type = 'info') => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 3500);
  }, []);

  const value = useMemo(() => ({ show }), [show]);

  return (
    <ToastCtx.Provider value={value}>
      {children}
      <div className="fixed bottom-6 right-6 z-[200] flex flex-col gap-2 pointer-events-none">
        {toasts.map(t => (
          <div
            key={t.id}
            data-testid="toast-message"
            className={`pointer-events-auto px-5 py-3 rounded-2xl border backdrop-blur-xl bg-gradient-to-r ${COLORS[t.type] || COLORS.info} text-white text-sm font-semibold shadow-2xl animate-slide-up max-w-sm truncate`}
          >
            {t.message}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error('useToast must be inside ToastProvider');
  return ctx;
}
